import { makeLogger } from "@/shared/consola";

const logger = makeLogger("service.helpers");

export function unwrapPaginatedResponse<R>(paginatedResponse: {
    results: R[];
    pagination: { page: number; size: number; total: number };
}): R[] {
    return paginatedResponse.results;
}

export function getAppOrigin() {
    return isCustomDomain() ? getCustomDomain() : process.env.VUE_APP_ORIGIN;
}

export function getAppOriginAPI() {
    return getAppOrigin() + "/" + (isCustomDomain() ? "_et" : "api");
}

export function isCustomDomain() {
    try {
        const baseHost = new URL(process.env?.VUE_APP_ORIGIN || "").hostname;
        const currentHost = window.location.hostname;
        const isCustom = baseHost !== currentHost;
        logger.debug(`This is ${isCustom ? "" : "NOT a "}custom domain`);
        return isCustom;
    } catch (e) {
        logger.error("Custom domain calculation problem", e);
        return false;
    }
}

export function getCustomDomain() {
    const customDomain = isCustomDomain() ? window.location.origin : "";
    if (!customDomain) {
        logger.warn("Custom domain NOT EXIST! but being requested, returning empty");
    }
    return customDomain;
}
